
window.saveBytes = (fileName, base64, contentType) => {
    const bin = atob(base64);
    const bytes = new Uint8Array(bin.length);
    for (let i = 0; i < bin.length; i++) bytes[i] = bin.charCodeAt(i);
    const blob = new Blob([bytes], { type: contentType || 'application/octet-stream' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a'); a.href = url; a.download = fileName || 'download';
    document.body.appendChild(a); a.click(); a.remove();
    URL.revokeObjectURL(url);
};